"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungslaengeUeberstandLockUtil = void 0;
const LeitungslaengeUeberstandLock_1 = require("./LeitungslaengeUeberstandLock");
class LeitungslaengeUeberstandLockUtil {
    static update(leitung) {
        var _a, _b, _c;
        // skip leitung if it already has the property set
        if (leitung.LaengeUeberstandLock != null)
            return;
        const hasLeitungsLaenge = ((_a = leitung.Leitungslaenge) === null || _a === void 0 ? void 0 : _a.Value) != null;
        const hasUeberstandFestpunkt = ((_b = leitung.UeberstandFestpunkt) === null || _b === void 0 ? void 0 : _b.Value) != null;
        const hasUeberstandMitnehmer = ((_c = leitung.UeberstandMitnehmer) === null || _c === void 0 ? void 0 : _c.Value) != null;
        // all 3 props have been set (by user and calc related to Kette) => take ueberstaende as its
        // the standard case
        if (hasLeitungsLaenge && hasUeberstandFestpunkt && hasUeberstandMitnehmer) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.festpunktAndMitnehmer);
        }
        // the next 3 cases happen when config started with a leitung and the kette has not yet be
        // defined. So no calc could have been performed yet.
        if (hasLeitungsLaenge && hasUeberstandFestpunkt) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.laengeAndFestpunkt);
        }
        if (hasLeitungsLaenge && hasUeberstandMitnehmer) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.laengeAndMitnehmer);
        }
        if (hasUeberstandFestpunkt && hasUeberstandMitnehmer) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.festpunktAndMitnehmer);
        }
        // these cases here should never happen, but maybe there was a bug somewhere and now its
        // messed up
        if (hasLeitungsLaenge) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.laengeOnly);
        }
        if (hasUeberstandFestpunkt) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.festpunktOnly);
        }
        if (hasUeberstandMitnehmer) {
            return (leitung.LaengeUeberstandLock = LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.mitnehmerOnly);
        }
        // if there is no prop set at all we leave the lock undefined
        return undefined;
    }
}
exports.LeitungslaengeUeberstandLockUtil = LeitungslaengeUeberstandLockUtil;
//# sourceMappingURL=LeitungslaengeUeberstandLockUtil.js.map